// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"2974eac4","282":"8fb92772","368":"396a3aa4","449":"e5be154c","512":"43f2f703","623":"6cbac42d"}[chunkId] + ".chunk.css";
};